import { Injectable, OnDestroy } from '@angular/core';
import { endpoint } from '@tekman/onmat/constants';
import { ProfileFacade } from '@tekman/onmat/store/profile';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService implements OnDestroy {
  private subscription: Subscription;
  private userID: string;

  constructor(
    private readonly profileFacade: ProfileFacade,
  ) {}

  get userId(): string {
    return this.userID;
  }

  public init() {
    this.setUserId();
  }

  private setUserId() {
    return this.profileFacade.userInfo$.subscribe(userInfo => {
      this.userID = userInfo.userId;
    });
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
}
